import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Sidebar } from "@/components/Sidebar";
import { AIAssistant } from "@/components/AIAssistant";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import VehicleList from "@/pages/VehicleList";
import VehicleDetail from "@/pages/VehicleDetail";
import Settings from "@/pages/Settings";
import FleetMap from "@/pages/FleetMap";
import UsersPage from "@/pages/Users";
import Activity from "@/pages/Activity";
import Billing from "@/pages/Billing";
import Drivers from "@/pages/Drivers";
import SetPassword from "@/pages/SetPassword";
import Landing from "@/pages/Landing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";

function Shell({ children }) {
  return (
    <div className="App">
      <Sidebar />
      {children}
      <AIAssistant />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center font-heading font-black text-xl">
        Chargement...
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/app" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { border: "2px solid #0F172A", borderRadius: "0.75rem", fontWeight: 600 } }} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<CheckoutSuccess />} />
          <Route path="/payment/cancel" element={<CheckoutCancel />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/vehicules" element={<Protected><VehicleList /></Protected>} />
          <Route path="/vehicules/:id" element={<Protected><VehicleDetail /></Protected>} />
          <Route path="/parametres" element={<Protected><Settings /></Protected>} />
          <Route path="/carte" element={<Protected><FleetMap /></Protected>} />
          <Route path="/utilisateurs" element={<Protected><UsersPage /></Protected>} />
          <Route path="/journal" element={<Protected><Activity /></Protected>} />
          <Route path="/facturation" element={<Protected><Billing /></Protected>} />
          <Route path="/conducteurs" element={<Protected><Drivers /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
